import { InputState } from './types';

const held: Record<string, boolean> = {};
const justPressed: Record<string, boolean> = {};

export function initInput(): void {
  window.addEventListener('keydown', (e) => {
    if (!held[e.code]) {
      justPressed[e.code] = true;
    }
    held[e.code] = true;
    // Prevent scroll on arrow/space
    if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Space'].includes(e.code)) {
      e.preventDefault();
    }
  });

  window.addEventListener('keyup', (e) => {
    held[e.code] = false;
  });

  // Mobile D-pad
  const dirs = ['up', 'down', 'left', 'right'] as const;
  const codeMap = { up: 'ArrowUp', down: 'ArrowDown', left: 'ArrowLeft', right: 'ArrowRight' };
  for (const dir of dirs) {
    const btn = document.getElementById(`btn-${dir}`);
    if (!btn) continue;
    btn.addEventListener('touchstart', (e) => {
      e.preventDefault();
      held[codeMap[dir]] = true;
    });
    btn.addEventListener('touchend', (e) => {
      e.preventDefault();
      held[codeMap[dir]] = false;
    });
    btn.addEventListener('touchcancel', () => { held[codeMap[dir]] = false; });
  }

  // Mobile action buttons
  const actionMap: Record<string, string> = {
    'btn-chop': 'Space',
    'btn-throw': 'KeyE',
    'btn-sell': 'KeyF',
    'btn-build': 'KeyB',
    'btn-craft': 'KeyC',
    'btn-pause': 'Escape',
  };
  for (const [id, code] of Object.entries(actionMap)) {
    const btn = document.getElementById(id);
    if (!btn) continue;
    btn.addEventListener('touchstart', (e) => {
      e.preventDefault();
      justPressed[code] = true;
      held[code] = true;
    });
    btn.addEventListener('touchend', (e) => {
      e.preventDefault();
      held[code] = false;
    });
    btn.addEventListener('touchcancel', () => { held[code] = false; });
    // Also support click for non-touch
    btn.addEventListener('mousedown', (e) => {
      e.preventDefault();
      justPressed[code] = true;
      held[code] = true;
    });
    btn.addEventListener('mouseup', (e) => {
      e.preventDefault();
      held[code] = false;
    });
  }

  // Detect touch device and show mobile controls
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    const mc = document.getElementById('mobile-controls');
    if (mc) mc.classList.remove('hidden');
  }
}

export function readInput(): InputState {
  const state: InputState = {
    up: !!(held['ArrowUp'] || held['KeyW']),
    down: !!(held['ArrowDown'] || held['KeyS']),
    left: !!(held['ArrowLeft'] || held['KeyA']),
    right: !!(held['ArrowRight'] || held['KeyD']),
    chop: !!justPressed['Space'],
    throw: !!justPressed['KeyE'],
    interact: !!justPressed['KeyF'],
    buildToggle: !!justPressed['KeyB'],
    craft: !!justPressed['KeyC'],
    pause: !!justPressed['Escape'],
    confirm: !!justPressed['Enter'],
  };
  // Clear edge-triggered
  for (const key of Object.keys(justPressed)) {
    justPressed[key] = false;
  }
  return state;
}
